/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "components/Button";
import Input from "components/Input";
import { useToaster } from "contexts/toasterContext";
import { customSelectStyles } from "util/selectStyles";
import { FormProvider, useForm } from "react-hook-form";
import Select from "react-select";
import apiService from "services/apiService";
import * as yup from "yup";

const emptyToZero = (value: unknown, originalValue: unknown) => {
  if (originalValue === "" || originalValue === undefined || originalValue === null) {
    return null;
  }
  return Number.isNaN(value) ? null : value;
};

const validationSchema = yup.object({
  appraisalType: yup.string().required("Appraisal type is required"),
  appraisalPercentage: yup
    .number()
    .transform(emptyToZero)
    .typeError("Appraisal percentage must be a valid number")
    .min(0, "Appraisal percentage cannot be negative")
    .max(100,"Apprisal percantage should be less than or equal to 100")
    .required("Appraisal percentage is required"),
});

interface OptionType {
  value: string;
  label: string;
}

interface OptionProps {
  employeeId: number;
  onClose: () => void;
}

const AddAppraisal = ({ employeeId, onClose }: OptionProps) => {
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      appraisalType: "",
      appraisalPercentage: "" as unknown as number,
    },
    mode: "onChange",
  });

  const { addToast } = useToaster();

  // Extract isDirty and isSubmitting from formState
  const { isDirty, isSubmitting } = methods.formState;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSubmit = (data: any) => {
    console.log("data", data);
    // Returning the promise allows react-hook-form to automatically handle the isSubmitting state
    return apiService
      .post(`/api/salary/appraisal/${employeeId}`, data)
      .then((response) => {
        console.log(response);
        addToast("Appraisal Added Successfully", "success");
      })
      .catch((error) => {
        console.log(error);
        addToast("Error Adding Appraisal", "error");
      })
      .finally(() => {
        onClose();
      });
  };

  const appraisalTypes: OptionType[] = [
    {
      value: "CTC_TYPE",
      label: "CTC Type",
    },
    {
      value: "BASIC_TYPE",
      label: "Basic Type",
    },
    // {
    //   value: "FIXED_TYPE",
    //   label: "Fixed Type",
    // },
    // {
    //   value: "VARIABLE_TYPE",
    //   label: "Variable Type",
    // },
    // {
    //   value: "OTHER_TYPE",
    //   label: "Other Type",
    // },
  ];

  return (
    <div>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <div className="grid md:grid-cols-2 sm:grid-cols-1 gap-4 p-2">
            <div>
              <label
                htmlFor="type"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Appraisal Type <span className="text-red-500">*</span>
              </label>
              <Select
                options={appraisalTypes}
                name="appraisalType"
                className="basic-single"
                classNamePrefix="select"
                isSearchable
                isClearable
                styles={customSelectStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuPlacement="auto"
                onChange={(selectedOption) => {
                  methods.setValue("appraisalType", selectedOption?.value || "", {
                    shouldValidate: true,
                    shouldDirty: true,
                    shouldTouch: true,
                  });
                }}
              ></Select>
              <div className="h-6 mt-1">
                {methods.formState.errors.appraisalType ? (
                  <span className="text-red-500 text-sm font-medium leading-tight block">
                    {methods.formState.errors.appraisalType.message as string}
                  </span>
                ) : (
                  <span className="invisible text-sm font-medium leading-tight block">
                    Placeholder error message
                  </span>
                )}
              </div>
            </div>

            {/* Removed min="0" so the browser allows the negative sign through to Yup validation */}
            <Input
              name="appraisalPercentage"
              label="Appraisal Percentage"
              type="number"
              required
            ></Input>
          </div>

          <div className="mt-1 w-full flex justify-center">
            <Button
              className="px-4 py-2 !text-white !bg-blue-700 hover:!bg-blue-800 focus:!ring-4 focus:!outline-none focus:!ring-blue-300 dark:!bg-blue-600 dark:hover:!bg-blue-700 dark:focus:!ring-blue-800 disabled:!opacity-50 disabled:!cursor-not-allowed"
              type="submit"
              disabled={!isDirty || isSubmitting}
            >
              Submit
            </Button>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};
export default AddAppraisal;